import { Component } from '@angular/core';

import { CxMessageModule } from '@bbraun/cortex/message';

import { TranslocoRootModule } from '@/app/transloco-root.module';

@Component({
  selector: 'app-screen-not-supported',
  imports: [TranslocoRootModule, CxMessageModule],
  templateUrl: './screen-not-supported.component.html',
})
export class ScreenNotSupportedComponent {}
